import PropTypes from 'prop-types';
import React from 'react';

import HeaderApprovalButton from './HeaderApprovalButton';
import Logo from '../../auth/pages/bedrock_wordmark.png';
import SettingsContainer from './SettingsContainer';
import NavbarToggle from '../../shared/components/NavbarToggle';

const SearchBar = ({
  isUserManager,
  location,
  username,
  company,
  currentUser,
  menuExpanded,
  toggleMenu
}) => (
  <header className="search-bar">
    <div className="search-bar-left">
      <div onClick={toggleMenu} className="navbar-toggle-container">
        <NavbarToggle isMenuExtended={menuExpanded} />
      </div>
      <img src={Logo} alt="TAIT Logo" />
      {isUserManager && <HeaderApprovalButton location={location} />}
    </div>
    <div className="search-bar-right">
      <SettingsContainer
        isUserManager={isUserManager}
        username={username}
        company={company}
        currentUser={currentUser}
      />
    </div>
  </header>
);

SearchBar.propTypes = {
  username: PropTypes.string.isRequired,
  isUserManager: PropTypes.bool.isRequired,
  menuExpanded: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired
};

export default SearchBar;
